module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"ddd":"DDD"},"en-US":{"ddd":"DDD"}}')
  delete Component.options._Ctor
}
